// @ts-nocheck
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getUserById } from "../../../features/auth"; // Replace with actual path
import {
  Typography,
  Box,
  Grid,
  Paper,
  IconButton,
  Tooltip,
} from "@mui/material";
import { FaEye } from "react-icons/fa";
import SoftBox from "../../../components/common/softBox";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";
import DashboardLayout from "../../../components/layoutContainers/dashboardLayout";

const ViewUser = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { user } = useSelector((state: any) => state.auth);

  useEffect(() => {
    if (id) {
      dispatch(getUserById(id));
    }
  }, [id, dispatch]);

  if (!user || Object.keys(user).length === 0) {
    return (
      <SoftBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Typography variant="h6">Loading user details...</Typography>
      </SoftBox>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SoftBox>
        <Paper elevation={4} sx={{ borderRadius: 3, p: 3 }}>
          <Typography variant="h5" fontWeight="bold" gutterBottom align="left">
            User Details
          </Typography>

          <Grid container spacing={2}>
            {/* Left Column */}
            <Grid item xs={12} sm={6}>
              <Typography variant="body1" className="details_style_tytle" >
                <strong>Name:</strong> {user.owner_name}
              </Typography>
              <Typography variant="body1" className="details_style_tytle">
                <strong >Email:</strong> {user.email}
              </Typography>
              <Typography variant="body1" className="details_style_tytle">
                <strong >Mobile Number:</strong> {user.mobile_number}
              </Typography>
              <Typography variant="body1" className="details_style_tytle">
                <strong >Address:</strong> {user.national_address}
              </Typography>
              <Typography variant="body1" className="details_style_tytle">
                <strong >Status:</strong> {user.status}
              </Typography>
              <Typography variant="body1" className="details_style_tytle">
                <strong>Legal Approval:</strong>{" "}
                {user.legalApprove ? "Approved" : "Pending"}
              </Typography>
              <Typography variant="body1" className="details_style_tytle">
                <strong>Commercial Approval:</strong>{" "}
                {user.commercialApprove ? "Approved" : "Pending"}
              </Typography>
              {Array.isArray(user.userApprovals) &&
                user.userApprovals.length > 0 && (
                  <>
                    <Typography
                      variant="body1"
                      className="details_style_tytle"
                      sx={{ mt: 1 }}
                    >
                      <strong>Per-Company Approvals:</strong>
                    </Typography>
                    {user.userApprovals.map((approval, idx) => (
                      <Typography
                        key={`${approval.companyCode}-${idx}`}
                        variant="body2"
                        className="details_style_tytle"
                        sx={{ pl: 2 }}
                      >
                        {approval.companyName ||
                          `Company ${approval.companyCode}`}{" "}
                        ({approval.companyCode}): Legal{" "}
                        {approval.legalApprove ? "Approved" : "Pending"},
                        Commercial{" "}
                        {approval.commercialApprove ? "Approved" : "Pending"}
                      </Typography>
                    ))}
                  </>
                )}
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} sm={6}>
              <Typography variant="body1" className="details_style_tytle">
                <strong >SAP Number:</strong> {user.sap_no || "N/A"}
              </Typography>
              <Typography variant="body1" className="details_style_tytle">
                <strong >GLN:</strong> {user.gln || "N/A"}
              </Typography>
              <Typography variant="body1" className="details_style_tytle">
                <strong >Promissory Note:</strong> {user.promisory_note || "N/A"}
              </Typography>
              {/* <Typography variant="body1" className="details_style_tytle">
                <strong >Created At:</strong>{" "}
                {new Date(user.created_at).toLocaleString()}
              </Typography> */}
              {/* <Typography variant="body1" className="details_style_tytle">
                <strong >Updated At:</strong>{" "}
                {new Date(user.updated_at).toLocaleString()}
              </Typography> */}
            </Grid>
          </Grid>

          {/* File Links Section */}
          <Box mt={2}>
            <Typography variant="h6" fontWeight="bold">
              Documents
            </Typography>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" className="details_style_tytle">
                  <strong >Commercial Registration:</strong>
                  {user.fullPaths?.commorcial_registration ? (
                    <Tooltip title="View Document">
                      <IconButton
                        component="a"
                        href={user.fullPaths.commorcial_registration}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaEye />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    " N/A"
                  )}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" className="details_style_tytle">
                  <strong >Health License:</strong>
                  {user.fullPaths?.helth_licence ? (
                    <Tooltip title="View Document">
                      <IconButton
                        component="a"
                        href={user.fullPaths.helth_licence}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaEye />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    " N/A"
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" className="details_style_tytle" >
                  <strong>Expiry Date:</strong>
                  {user?.exp_date
                    ? new Date(user?.exp_date).toLocaleString()
                    : "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" className="details_style_tytle">
                  <strong>Expiry Date:</strong>
                  {user?.health_exp_date
                    ? new Date(user?.health_exp_date).toLocaleString()
                    : "N/A"}
                </Typography>
              </Grid>
            </Grid>

            {/* Signature */}
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" className="details_style_tytle">
                  <strong>Signature:</strong>
                </Typography>
                {user?.signature_id?.signature_data ? (
                  <Box
                    component="img"
                    alt="Customer signature"
                    src={
                      String(user.signature_id.signature_data).startsWith(
                        "data:"
                      )
                        ? user.signature_id.signature_data
                        : `data:image/png;base64,${user.signature_id.signature_data}`
                    }
                    sx={{
                      mt: 1,
                      maxWidth: 240,
                      border: "1px solid #e0e0e0",
                      borderRadius: 1,
                      backgroundColor: "#fff",
                    }}
                  />
                ) : (
                  <Typography variant="body2">N/A</Typography>
                )}
              </Grid>
            </Grid>

            {/* Other Files */}
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12}>
                <Typography variant="body1" className="details_style_tytle">
                  <strong>Other Files:</strong>
                </Typography>
                {user.fullPaths?.other_files &&
                user.fullPaths.other_files.length > 0 ? (
                  <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
                    {user.fullPaths.other_files.map(
                      (file: string, index: number) => (
                        <Tooltip title="View Document" key={index}>
                          <IconButton
                            component="a"
                            href={file}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FaEye />
                          </IconButton>
                        </Tooltip>
                      )
                    )}
                  </Box>
                ) : (
                  <Typography variant="body2">N/A</Typography>
                )}
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </SoftBox>
    </DashboardLayout>
  );
};

export default ViewUser;
